export const EnvSchema = {
  DOCFLOW_ADMIN_ORIGIN: "",
  DOCFLOW_CLIENT_ORIGIN: "",
  DOCFLOW_SERVER_ORIGIN: "",
  BANK_131_PROXY_ORIGIN: "",
  BANK_131_WIDGET_ORIGIN: "",
  DEFAULT_CONTRACTOR: "",
  DEFAULT_CURRENCY: "",
  FIN_DEP_LINK: "",
  SMART_GLOCAL_WIDGET_JS: "",
  SMART_GLOCAL_WIDGET_CSS: "",
  SSO_LINK: "",
  TEAMWOX_ORIGIN: "",
};

export const ENV_ENTRY_POINT = "/env";

export type RuntimeEnvironments = typeof EnvSchema;
